import React from 'react'
import { HelpDefinition } from "../configs/configCommons"

const deafultHelpDefinition: HelpDefinition = {
}

export default deafultHelpDefinition